// appMode.js — Kid Mode vs Grown-up Mode. Deliberate entry, obvious exit.
import { useEffect, useState } from "react";

const KEY = "mwq_app_mode_v1";
export const GROWNUP_HOME = "/grown-ups";

export function getMode() {
  try { return localStorage.getItem(KEY) === "grownup" ? "grownup" : "kid"; } catch { return "kid"; }
}
export function setMode(mode) {
  try { localStorage.setItem(KEY, mode === "grownup" ? "grownup" : "kid"); } catch { /* ignore */ }
  // Deferred so listeners attached in the same commit (useAppMode) always receive it.
  try { setTimeout(() => window.dispatchEvent(new Event("mwq-mode-changed")), 0); } catch { /* ignore */ }
}
export function useAppMode() {
  const [m, setM] = useState(getMode);
  useEffect(() => {
    const f = () => setM(getMode());
    window.addEventListener("mwq-mode-changed", f);
    window.addEventListener("storage", f);
    return () => { window.removeEventListener("mwq-mode-changed", f); window.removeEventListener("storage", f); };
  }, []);
  return m;
}

// Grown-up primary nav — Learners · Progress · Curriculum · Reports · Settings
export const GROWNUP_NAV = [
  { key: "gu-learners",   label: "Learners",   to: "/grown-ups/learners",   emoji: "👨‍👩‍👧" },
  { key: "gu-progress",   label: "Progress",   to: "/grown-ups/progress",   emoji: "📈" },
  { key: "gu-curriculum", label: "Curriculum", to: "/grown-ups/curriculum", emoji: "📚" },
  { key: "gu-reports",    label: "Reports",    to: "/grown-ups/reports",    emoji: "🖨️" },
  { key: "gu-settings",   label: "Settings",   to: "/grown-ups/settings",   emoji: "🔒" },
];
